import * as helpers from "./helpers";
const map = {
    ResidenceDuration: {
        fields: [
            "PrevStreetAddress1",
            "PrevCity",
            "PrevState",
            "PrevZip",
            "PrevResidenceDuration",
            "PrevResidenceType",
        ],
        updateHandler: (field) => {
            const prevAddressSect = document.getElementById("prevAddressSection");
            const fieldset = prevAddressSect.querySelector("fieldset");
            const years = parseInt(field.value);
            if (years < 2) {
                fieldset.removeAttribute("disabled");
                prevAddressSect.removeAttribute("hidden");
            }
            else {
                fieldset.setAttribute("disabled", "true");
                prevAddressSect.setAttribute("hidden", "true");
            }
        },
    },
    EmploymentStatus: {
        fields: ["Income", "IncomeBasis"],
        updateHandler: (field) => {
            helpers.makeFieldsRequired(field.form, ["IncomeBasis", "Income"]);
        },
    },
    EmploymentDuration: {
        fields: ["PrevEmploymentStatus"],
        updateHandler: (field) => {
            const prevSect = document.getElementById("prevEmploymentSection");
            const fieldset = prevSect.querySelector("fieldset");
            const months = parseInt(field.value);
            if (months < 24) {
                prevSect.removeAttribute("hidden");
                fieldset.removeAttribute("disabled");
            }
            else {
                prevSect.setAttribute("hidden", "true");
                fieldset.setAttribute("disabled", "true");
            }
        },
    },
    IncomeBasis: {
        fields: ["Income"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.Income),
    },
    AddIncome: {
        fields: [],
        updateHandler: (field) => helpers.showHideAdditionalIncome(field),
    },
    AdditionalIncomeBasis: {
        fields: ["AdditionalIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.AdditionalIncome),
    },
    PrevEmploymentStatus: {
        fields: ["PrevIncome", "PrevIncomeBasis"],
        updateHandler: (field) => {
            helpers.makeFieldsRequired(field.form, ["PrevIncomeBasis", "PrevIncome"]);
        },
    },
    PrevIncomeBasis: {
        fields: ["PrevIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.PrevIncome),
    },
    PrevAddIncome: {
        fields: [],
        updateHandler: (field) => helpers.showHideAdditionalIncome(field),
    },
    PrevAdditionalIncomeBasis: {
        fields: ["PrevAdditionalIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.PrevAdditionalIncome),
    },
    AddCoApp: {
        fields: [],
        updateHandler: (field) => {
            const section = document.getElementById("coAppInfo");
            const fieldsets = section.querySelectorAll("fieldset");
            if (field.checked) {
                section.removeAttribute("hidden");
                for (const fs of fieldsets) {
                    if (fs.hasAttribute("hidden")) {
                        fs.setAttribute("disabled", "true");
                    }
                    else {
                        fs.removeAttribute("disabled");
                    }
                }
            }
            else {
                section.setAttribute("hidden", "true");
                for (const fs of fieldsets) {
                    fs.setAttribute("disabled", "true");
                }
            }
        },
    },
    CoAppResidenceDuration: {
        fields: [
            "CoAppPrevStreetAddress1",
            "CoAppPrevCity",
            "CoAppPrevState",
            "CoAppPrevZip",
            "CoAppPrevResidenceDuration",
            "CoAppPrevResidenceType",
        ],
        updateHandler: (field) => {
            const prevAddressSect = document.getElementById("coAppPrevAddressSection");
            const fieldset = prevAddressSect.querySelector("fieldset");
            const years = parseInt(field.value);
            if (years < 2) {
                fieldset.removeAttribute("disabled");
                prevAddressSect.removeAttribute("hidden");
            }
            else {
                fieldset.setAttribute("disabled", "true");
                prevAddressSect.setAttribute("hidden", "true");
            }
        },
    },
    CoAppEmploymentStatus: {
        fields: ["CoAppIncome", "CoAppIncomeBasis"],
        updateHandler: (field) => {
            helpers.makeFieldsRequired(field.form, [
                "CoAppIncomeBasis",
                "CoAppIncome",
            ]);
        },
    },
    CoAppEmploymentDuration: {
        fields: ["CoAppPrevEmploymentStatus"],
        updateHandler: (field) => {
            const prevSect = document.getElementById("coAppPrevEmploymentSection");
            const fieldset = prevSect.querySelector("fieldset");
            const months = parseInt(field.value);
            if (months < 24) {
                prevSect.removeAttribute("hidden");
                fieldset.removeAttribute("disabled");
            }
            else {
                prevSect.setAttribute("hidden", "true");
                fieldset.setAttribute("disabled", "true");
            }
        },
    },
    CoAppIncomeBasis: {
        fields: ["CoAppIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.CoAppIncome),
    },
    CoAppAddIncome: {
        fields: [],
        updateHandler: (field) => helpers.showHideAdditionalIncome(field),
    },
    CoAppAdditionalIncomeBasis: {
        fields: ["CoAppAdditionalIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.CoAppAdditionalIncome),
    },
    CoAppPrevEmploymentStatus: {
        fields: ["CoAppPrevIncome", "CoAppPrevIncomeBasis"],
        updateHandler: (field) => {
            helpers.makeFieldsRequired(field.form, [
                "CoAppPrevIncomeBasis",
                "CoAppPrevIncome",
            ]);
        },
    },
    CoAppPrevIncomeBasis: {
        fields: ["CoAppPrevIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.CoAppPrevIncome),
    },
    CoAppPrevAddIncome: {
        fields: [],
        updateHandler: (field) => helpers.showHideAdditionalIncome(field),
    },
    CoAppPrevAdditionalIncomeBasis: {
        fields: ["CoAppPrevAdditionalIncome"],
        updateHandler: (field) => helpers.updateIncomeField(field.value, field.form.CoAppPrevAdditionalIncome),
    },
};
export default map;
